import { Link } from "react-router-dom";

export default function EarlyAccess() {
  return (
    <div className="py-12" style={{ backgroundColor: "#1E1E1E" }}>
      <div className="text-white container mx-auto flex flex-col items-center justify-center p-3 space-y-8 md:p-10 md:px-24 xl:px-48">
        <h1 className="text-4xl font-bold leading-none text-center">
          Want to be the first one to use Envolvly?
        </h1>
        <h1 className="text-primary-400 text-5xl font-bold leading-none text-center">
          Become an Ambassador
        </h1>
        <h1 className="text-white text-md font-bold leading-none text-center w-2/3">
          The Envolvly Ambassador Program is a personalized program that
          provides chosen creators with early-access to new features, insider
          insights, and more.
        </h1>
        <Link to="/ambassador">
          <button className="bg-gradient-to-r from-primary-500 to-primary-600 hover:from-primary-600 hover:to-primary-700 text-white text-xl font-semibold py-4 px-10 rounded-lg shadow-lg hover:shadow-2xl transform hover:-translate-y-1 transition-all duration-300 ease-in-out">
            APPLY
          </button>
        </Link>
      </div>
    </div>
  );
}
